import { AutocompleteInput } from "@enpowered/ui";
import { Field, Form, Formik } from "formik";
import PropTypes from "prop-types";
import React from "react";

import { defaultProvisionMeter, meterTypes } from "./meters-data";

const ProvisionMeterForm = ({ formComplete, autocompleteData }) => {
  const submitChanges = () => {
    if (formComplete) {
      formComplete();
    }
    // This is where we would call out to make the updates
  };

  const cancelChanges = () => {
    if (formComplete) {
      formComplete();
    }
  };

  const renderMeterTypes = () => {
    const meterTypeOptions = meterTypes.map(meterType => (
      <option key={meterType} value={meterType}>
        {meterType}
      </option>
    ));
    meterTypeOptions.unshift(
      <option key="blank" value="">
        Choose a meter type
      </option>
    );
    return meterTypeOptions;
  };

  const getOptionLabel = option => {
    return option.customerName;
  };

  return (
    <div className="flex flex-col justify-center">
      <label className="text-center text-2xl">Meter Provisioning</label>
      <Formik
        initialValues={defaultProvisionMeter}
        enableReinitialize
        onSubmit={submitChanges}
        onReset={cancelChanges}
      >
        {({ handleSubmit }) => (
          <Form className="px-4 pt-4" onSubmit={handleSubmit}>
            <div>
              <Field name="customerName" type="text">
                {({ form }) => {
                  const onSelected = val => {
                    form.values.customer = val;
                  };
                  return (
                    <AutocompleteInput
                      className={{
                        "w-full mb-2 truncate": true,
                        "focus:border-en-yellow-600": false,
                        "focus:border-en-green": true,
                        "border-en-gray-400": false,
                        "border-en-gray-100": true
                      }}
                      placeholder="Customer"
                      autocompleteData={autocompleteData}
                      getOptionLabel={getOptionLabel}
                      maxResults={5}
                      onSelected={onSelected}
                    />
                  );
                }}
              </Field>
            </div>

            <div>
              <Field
                className="border rounded w-full text-gray-700 leading-tight py-2 px-4 mb-2 truncate"
                placeholder="Meter Type"
                name="meterType"
                as="select"
              >
                {renderMeterTypes()}
              </Field>
            </div>

            <div>
              <Field
                className="input mb-2 truncate"
                placeholder="Meter ID"
                name="meterId"
                type="text"
              />
            </div>

            <div>
              <Field
                className="input mb-2 truncate"
                placeholder="Date (YYYY/MM/DD)"
                name="dateProvisioned"
                type="text"
              />
            </div>

            <div>
              <Field
                className="input mb-2 truncate"
                placeholder="Notes"
                name="notes"
                component="textarea"
              />
            </div>

            <div className="flex justify-end">
              <div>
                <button
                  className="bg-blue-500 text-white font-bold py-2 px-4 rounded focus:bg-blue-700 focus:outline-none m-1"
                  type="submit"
                >
                  Submit
                </button>
              </div>
              <div>
                <button
                  className="bg-blue-500 text-white font-bold py-2 px-4 rounded focus:bg-blue-700 focus:outline-none m-1"
                  type="reset"
                >
                  Cancel
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

ProvisionMeterForm.propTypes = {
  formComplete: PropTypes.func,
  autocompleteData: PropTypes.arrayOf(PropTypes.object)
};

export default ProvisionMeterForm;
